export default __webpack_public_path__ + "9810070279ff36c4ac19f9af64639309.png";